import $ from 'jquery';
import Component from './Component';


const getElementValue = el => {
  switch (el.type.toLowerCase())  {
    case 'checkbox':
    case 'radio':
      return el.checked ? el.value : null;
    case 'select-one':
      const selectedIndex = el.selectedIndex
      return selectedIndex >= 0 ? el.options[selectedIndex].value : null;
    case 'select-multiple':
      var values = [];
      for (let option, i = 0; option = el.options[i]; i++) {
        if (option.selected) {
          values.push(option.value);
        }
      }
      return values.length ? values : null;
    default:
      return el.value != null ? el.value : null;
  }
};

export default class MultipleWidgetContainerItem extends Component {
  constructor(props) {
    super(props);
    this.onRemoveClick = this.onRemoveClick.bind(this);
  }
  getDefaultProps() {
    return {
      /**
       * @type {boolean}
       */
      removable: false,
      onItemRemove: (index) => {},
      removeBtnTemplate: '<button type="button">Odebrat</button>',
      addBtn: null,
      toolbarClassName: ''
    };
  }
  decorateInternal() {
    this.toolbar = $('<div class="multiply-container-item-toolbar ' + this.props.toolbarClassName + '"></div>');
    this.element.append(this.toolbar);
  }
  onRemoveClick() {
    const {onItemRemove} = this.props;
    onItemRemove(this);
  }

  getRemoveBtn() {
    const {removeBtnTemplate} = this.props;
    if (!this.removeBtn) {
      this.removeBtn = $(removeBtnTemplate).appendTo(this.toolbar);
      this.removeBtn.on('click', this.onRemoveClick);
    }
    return this.removeBtn;
  }
  removeRemoveBtn() {
    if (this.removeBtn) {
      this.removeBtn.off('click', this.onRemoveClick);
      this.removeBtn.remove();
      this.removeBtn = null;
    }
  }
  getLastInputField() {
    const inputs = this.element.find(':input:not("disabled"):not("readonly"):not([type=image],[type=button],[type=submit],[type=radio],[type=checkbox]), textarea');
    return inputs.last();
  }
  hasValue() {
    const inputFields = this.element.find(':input:not("disabled"):not("readonly")');
    const inputFieldsWithValue = inputFields.filter( (index, el) => {
      return !!getElementValue(el);
    });
    return inputFieldsWithValue.length > 0;
  }
  updateInternal() {
    const {removable} = this.props;
    if (removable) {
      this.getRemoveBtn();
    }
    else {
      this.removeRemoveBtn();
    }
  }
  dispose() {
    this.removeBtn.off('click', this.onRemoveClick);
    this.removeBtn.remove();
    this.removeBtn = null;
    this.toolbar.remove();
    this.toolbar = null;
    super.dispose();
  }


}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/web/MultipleWidgetContainer/MultiplyWidgetContainerItem.js